import React from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import Icon from 'react-native-vector-icons/Ionicons';

import { MainTabParamList } from '@/types/navigation';
import DashboardNavigator from '@/navigation/DashboardNavigator';
import TimeClockNavigator from '@/navigation/TimeClockNavigator';
import ScheduleNavigator from '@/navigation/ScheduleNavigator';
import ClassesNavigator from '@/navigation/ClassesNavigator';
import MessagesNavigator from '@/navigation/MessagesNavigator';
import ProfileScreen from '@/screens/profile/ProfileScreen';

const Tab = createBottomTabNavigator<MainTabParamList>();

const MainNavigator: React.FC = () => (
  <Tab.Navigator
    screenOptions={({ route }) => ({
      tabBarIcon: ({ focused, color, size }) => {
        let iconName: string;
        switch (route.name) {
          case 'Dashboard':
            iconName = focused ? 'home' : 'home-outline';
            break;
          case 'TimeClock':
            iconName = focused ? 'time' : 'time-outline';
            break;
          case 'Schedule':
            iconName = focused ? 'calendar-number' : 'calendar-number-outline';
            break;
          case 'Classes':
            iconName = focused ? 'body' : 'body-outline';
            break;
          case 'Messages':
            iconName = focused ? 'chatbubbles' : 'chatbubbles-outline';
            break;
          case 'Profile':
            iconName = focused ? 'person' : 'person-outline';
            break;
          default:
            iconName = 'circle';
        }
        return <Icon name={iconName} size={size} color={color} />;
      },
      tabBarActiveTintColor: '#007AFF',
      tabBarInactiveTintColor: '#8E8E93',
      tabBarStyle: {
        backgroundColor: '#FFFFFF',
        borderTopColor: '#E5E5EA',
        height: 85,
        paddingBottom: 20,
        paddingTop: 10,
      },
      headerStyle: { backgroundColor: '#007AFF' },
      headerTintColor: '#FFFFFF',
      headerTitleStyle: { fontWeight: 'bold' },
    })}>
    <Tab.Screen
      name="Dashboard"
      component={DashboardNavigator}
      options={{ title: 'Dashboard', headerShown: false }}
    />
    <Tab.Screen
      name="Classes"
      component={ClassesNavigator}
      options={{ title: 'Classes', headerShown: false }}
    />
    <Tab.Screen
      name="TimeClock"
      component={TimeClockNavigator}
      options={{ title: 'Time', headerShown: false }}
    />
    <Tab.Screen
      name="Schedule"
      component={ScheduleNavigator}
      options={{ title: 'Schedule', headerShown: false }}
    />
    <Tab.Screen
      name="Messages"
      component={MessagesNavigator}
      options={{ title: 'Messages', headerShown: false }}
    />
    <Tab.Screen
      name="Profile"
      component={ProfileScreen}
      options={{ title: 'Profile', headerTitle: 'My Profile' }}
    />
  </Tab.Navigator>
);

export default MainNavigator;
